import React, { useEffect, useState } from 'react';
import { HistoryOutlined, ManageAccountsOutlined } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import SwalWithA11yFix from '../../services/swalConfig';
import TestHistory from '../../components/patient/TestHistory';
import DashboardLayout from '../../components/common/DashboardLayout';
import ProfileEditor from '../../components/common/ProfileEditor';

const PatientDashboard = () => {
  const [tests, setTests] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const { user, logout, updateUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetchTests();
  }, []);

  const fetchTests = async () => {
    try {
      const response = await api.get('/patient/tests');
      setTests(response.data);
    } catch (error) {
      console.error('Error fetching tests:', error);
    }
  };

  const handleLogout = async () => {
    const result = await SwalWithA11yFix({
      title: 'Are you sure?',
      text: 'You will be logged out of your account',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1976d2',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, logout',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      logout();
      await SwalWithA11yFix({
        icon: 'success',
        title: 'Logged Out!',
        text: 'You have been successfully logged out.',
        timer: 1500,
        showConfirmButton: false,
      });
      navigate('/login');
    }
  };

  const menuItems = [
    {
      icon: <HistoryOutlined />,
      label: 'Test History',
      active: activeTab === 0,
      onClick: () => setActiveTab(0),
    },
    {
      icon: <ManageAccountsOutlined />,
      label: 'Edit Profile',
      active: activeTab === 1,
      onClick: () => setActiveTab(1),
    },
  ];

  return (
    <DashboardLayout
      title="Patient Dashboard"
      user={user}
      onLogout={handleLogout}
      menuItems={menuItems}
      logoutPath="/login"
      topHeading={activeTab === 0 ? 'Test History' : 'Edit Profile'}
    >
      {activeTab === 0 && <TestHistory tests={tests} onUpdate={fetchTests} />}
      {activeTab === 1 && <ProfileEditor user={user} onProfileUpdated={updateUser} />}
    </DashboardLayout>
  );
};

export default PatientDashboard;

